export const defaultHideIfZeroTag = 'Condition_HideIfZero';

type ConditionTagInput = string | Array<string | undefined> | undefined;

const normalizeConditionTag = (conditionTag?: string) => {
  const trimmedTag = conditionTag?.trim();

  if (!trimmedTag) return defaultHideIfZeroTag;

  return trimmedTag.replace(/^<\/?([^>\s]+).*$/, '$1');
};

const normalizeConditionTags = (conditionTags?: ConditionTagInput) => {
  const tags = Array.isArray(conditionTags) ? conditionTags : [conditionTags];
  const normalizedTags = tags
    .filter(Boolean)
    .map((tag) =>
      normalizeConditionTag(tag));

  return Array.from(
    new Set(normalizedTags.length ? normalizedTags : [defaultHideIfZeroTag]),
  );
};

export const getConditionTags = (conditionTag?: string) => {
  const tag = normalizeConditionTag(conditionTag);

  return {
    closeTag: `</${tag}>`,
    escapedCloseTag: `&lt;/${tag}&gt;`,
    escapedOpenTag: `&lt;${tag}&gt;`,
    openTag: `<${tag}>`,
  };
};

export const serializeEmailConditions = (html?: string, conditionTags?: ConditionTagInput) =>
  normalizeConditionTags(conditionTags).reduce((serializedHtml, conditionTag) => {
    const {
      closeTag,
      escapedCloseTag,
      escapedOpenTag,
      openTag,
    } = getConditionTags(conditionTag);

    return serializedHtml
      .split(escapedOpenTag)
      .join(openTag)
      .split(escapedCloseTag)
      .join(closeTag);
  }, html ?? '');

export const deserializeEmailConditions = (html?: string, conditionTags?: ConditionTagInput) =>
  normalizeConditionTags(conditionTags).reduce((deserializedHtml, conditionTag) => {
    const {
      closeTag,
      escapedCloseTag,
      escapedOpenTag,
      openTag,
    } = getConditionTags(conditionTag);

    return deserializedHtml
      .split(openTag)
      .join(escapedOpenTag)
      .split(closeTag)
      .join(escapedCloseTag);
  }, html ?? '');
